<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-27 10:36:18
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceRecord\components\AttendancePlan.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-27 14:49:27
-->
<template>
  <v-container fluid class="rounded-lg pa-3 white" ref="attplan">
    <!-- loading -->
    <v-sheet
      class="
        loading_container
        text-center
        d-flex
        align-center
        justify-center
        fill-height
        rounded-lg
      "
      v-if="loading"
      :width="$refs['attplan'].offsetWidth"
    >
      <v-progress-circular
        indeterminate
        size="20"
        width="2"
        color="primary"
      ></v-progress-circular>
    </v-sheet>
    <!-- loading/ -->
    <!-- 分页 -->
    <v-row dense no-gutters style="height: 32px" class="mb-2">
      <v-col md="12" class="text-center pa-0 align-center d-flex justify-start">
        <v-btn
          small
          color="white"
          shaped
          class="text-button primary--text mr-4"
          :disabled="$getDateTime(new Date(), 'YYYY-MM-DD') === curDate"
          @click="onTrigerPage(null)"
          >{{ $t("label_essweb_system_todayLabel") }}
        </v-btn>
        <v-btn
          icon
          small
          color="secondary"
          class="transparent"
          @click="onTrigerPage('red')"
        >
          <span class="material-icons-round">chevron_left</span>
        </v-btn>
        <v-sheet
          color="transparent"
          class="mx-6 text-capitalize text-button text--secondary"
        >
          {{
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(startTime, "YYYY"),
              month: $getDateTime(startTime, "MM"),
              day: $getDateTime(startTime, "DD"),
            }) +
            " - " +
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(endTime, "YYYY"),
              month: $getDateTime(endTime, "MM"),
              day: $getDateTime(endTime, "DD"),
            })
          }}</v-sheet
        >
        <v-btn
          icon
          small
          color="secondary"
          class="transparent"
          @click="onTrigerPage('add')"
        >
          <span class="material-icons-round">chevron_right</span>
        </v-btn>
        <v-menu
          v-model="selectedDay"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              class="ml-4 transparent"
              color="secondary"
              readonly
              v-bind="attrs"
              v-on="on"
            >
              <span class="material-icons-round">event</span>
            </v-btn>
          </template>
          <v-date-picker
            v-model="curDate"
            no-title
            :show-current="false"
            color="primary"
            flat
            scrollable
            :day-format="
              (date) => {
                return $getDateTime(date, 'D');
              }
            "
            :locale="defaultLang"
            @input="onSelectDay"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <!-- 分页/ -->
    <!-- 日期 -->
    <v-row
      dense
      no-gutters
      style="border-bottom: 1px solid var(--main-border-color); height: 50px"
      class="pb-0"
    >
      <v-col
        v-for="n in cycleType + 1"
        :key="n + 'col'"
        :cols="n === 1 ? 2 : undefined"
        class="text-center fill-height pa-0 align-center"
        :style="{
          borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
        }"
      >
        <v-card
          class="pa-0 fill-height align-end align-items-end"
          :elevation="0"
          tile
        >
          <template v-if="n != 1">
            <div class="fill-height max-width d-flex justify-end flex-column">
              <DaySelect
                :time="curPageDate[n - 2]"
                :selectStartDate="selectStartDate"
                :selectEndDate="selectEndDate"
              />
            </div>
          </template> </v-card
      ></v-col>
    </v-row>
    <!-- 日期/ -->
    <!-- main -->
    <v-container
      class="max-width pa-0 ma-0 rounded-lg scroll"
      fluid
      :style="{
        overflow: 'overlay',
        height: $vuetify.breakpoint.height - 460 + 46 + 'px',
      }"
    >
      <v-sheet v-if="RosterList.length <= 0" height="300"></v-sheet>
      <v-row
        dense
        no-gutters
        class="max-width flex-wrap"
        v-for="(tr, index) in RosterList"
        :key="index + 'roster'"
        style="height: 100px"
      >
        <v-col
          v-for="n in cycleType + 1"
          :key="n + 'col'"
          :cols="n === 1 ? 2 : undefined"
          :style="{
            borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
          }"
          class="text-center max-width fill-height align-center"
        >
          <attCard
            :col="n"
            :curType="cycleType"
            :curData="tr"
            @onShift="
              (data, date, master) => {
                $emit('onShift', data, date, master);
              }
            "
            :selectStaffs="selectStaffs"
            :iSEdited="iSEdited"
            :shiftList="shiftList"
            :selectStartDate="selectStartDate"
            :selectEndDate="selectEndDate"
            :curDate="curPageDate[n - 2]"
          />
        </v-col>
      </v-row>
    </v-container>
    <!-- main/ -->
    <!-- 分页 -->
    <v-row
      dense
      no-gutters
      v-if="RosterList.length"
      style="border-top: 1px solid var(--main-border-color)"
    >
      <v-col
        md="12"
        class="text-center pa-0 align-center d-flex justify-center"
      >
        <v-sheet
          class="
            pa-2
            pb-0
            max-width
            d-flex
            flex-nowrap
            align-center
            justify-space-between
          "
        >
          <!-- <TableManageTools v-if="showSelect" /> -->
          <span class="text-caption text--secondary">
            {{ other }}
            {{ $t("label_essweb_list_components_pagenations_columnLabel") }}({{
              $t("label_essweb_list_components_pagenations_totalLabel")
            }}
            {{ Number(totalCount) == 0 ? RosterList.length : totalCount }}
            {{ $t("label_essweb_list_components_pagenations_columnLabel") }})
          </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            color="grey lighten-2 "
            class="text--primary d-inline-block text-truncate text-center"
            prev-icon="navigate_before"
            next-icon="navigate_next"
            :length="
              Number(totalCount) == 0
                ? 1
                : Math.ceil(
                    totalCount /
                      (itemsPerPage == -1 ? totalCount : itemsPerPage)
                  )
            "
            :total-visible="7"
          />
          <v-spacer></v-spacer>
          <span class="text-caption text--secondary pr-1">{{
            $t("label_essweb_list_components_pagenations_perpageLabel")
          }}</span>
          <v-menu offset-y small>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                width="60"
                height="28"
                outlined
                depressed
                style="
                  border-color: rgba(0, 0, 0, 0.1) !important;
                  border-radius: 6px;
                  min-width: 60px;
                "
                class="
                  mrc-border-solid
                  text-capitalize
                  pa-0
                  white
                  text-body-2
                  d-flex
                  justify-space-around
                "
                text
              >
                {{
                  itemsPerPage == -1
                    ? $t(
                        "label_essweb_list_components_pagenations_selectNumber_allLabel"
                      )
                    : itemsPerPage
                }}
                <i class="material-icons-round">arrow_drop_down</i>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(item, index) in [10, 20, 50]"
                :key="index"
                @click="itemsPerPage = item"
              >
                <v-list-item-title>{{
                  item == -1
                    ? $t(
                        "label_essweb_list_components_pagenations_selectNumber_allLabel"
                      )
                    : item
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import attCard from "@/Page/EssAdmin/Attendance/AttendanceRecord/components/attCard";
import DaySelect from "@/Page/Ess/Roster/RosterRecord/components/DaySelect";
export default {
  name: "AttendancePlan",
  components: {
    attCard,
    DaySelect,
  },
  props: {
    selectType: { default: "", type: [Number, String] },
    cycleType: { default: 14, type: Number },
    startTime: { default: "", type: String },
    iSEdited: { default: false, type: Boolean },
    endTime: { default: "", type: String },
    selectStartDate: { default: "", type: String },
    selectEndDate: { default: "", type: String },
    showExportOut: { default: false, type: Boolean },
    showExportIn: { default: false, type: Boolean },
    change: { default: 0, type: Number },
    showRecalcul: { default: false, type: Boolean },
    showRosterForm: { default: false, type: Boolean },
    filterData: { default: null, type: [Array, Object, String, Number] },
    toDo: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...mapGetters(["companyLang", "defaultLang"]),
    totalDay() {
      if (this.startTime && this.endTime) {
        return dayjs(this.endTime).diff(dayjs(this.startTime), "day") + 1;
      } else {
        return 0;
      }
    },
    allDayByPage() {
      var arr = [];
      const that = this;
      const chunk = this.cycleType;
      if (that.allDay.length)
        for (var i = 0, j = that.allDay.length; i < j; i += chunk) {
          arr.push(that.allDay.slice(i, i + chunk));
        }
      return arr;
    },
    allDay() {
      var arr = [];
      const that = this;
      if (this.startTime && this.endTime) {
        var daylen = dayjs(this.endTime).diff(dayjs(this.startTime), "day"); //总天数
        for (var i = 0; i <= daylen; i++) {
          arr.push(dayjs(that.startTime).add(i, "day").format("YYYY-MM-DD"));
        }
      }
      return arr;
    },
    curPageDate() {
      if (this.pageDate > 0) {
        return this.allDayByPage[this.pageDate - 1];
      } else {
        return this.allDayByPage[0];
      }
    },
    allStaffs() {
      let arr = [];
      this.RosterList.map((item) => {
        arr.push(Number(item.staff_id)); //2020-10-20 staff_id-->user_id
      });
      return arr;
    },
    other() {
      let start =
        this.page == 1
          ? 1
          : Number(this.itemsPerPage) * (Number(this.page) - 1) + 1;
      let end =
        this.page == 1
          ? Number(this.itemsPerPage) * Number(this.page)
          : Number(this.itemsPerPage) * Number(this.page);
      if (Number(end) > Number(this.totalCount) || this.itemsPerPage == -1) {
        end = Number(this.totalCount);
      }
      return start + " - " + end;
    },
  },
  data() {
    return {
      showRosterShift: false,
      selectStaffs: [],
      curData: null,
      pageDate: 1,
      page: 1,
      curDate: "",
      selectedDay: false,
      itemsPerPage: 20,
      totalCount: 0,
      isActive: 0,
      nowShow: false,
      showExIn: false,
      loading: false,
      RosterList: [],
      shiftList: [],
    };
  },
  mounted() {
    this.itemsPerPage = this.$tableSetting.perPageSize;
    this.getRosterList(1, this.itemsPerPage);
  },
  watch: {
    page(val) {
      if (val) this.getRosterList(val, this.itemsPerPage);
    },
    itemsPerPage(val) {
      this.getRosterList(1, val);
    },

    startTime(val) {
      this.curDate = val;
      if (val) this.getRosterList(1, this.itemsPerPage);
    },
    filterData: {
      handler(val) {
        if (val) this.getRosterList(1, this.itemsPerPage);
      },
      deep: true,
    },
  },
  methods: {
    onTrigerPage: function (logic) {
      this.$emit("onTrigerPage", logic);
    },
    onSelectDay(date) {
      this.selectedDay = false;
      this.$emit("onTrigerPage", "add", date);
    },
    getRosterList(page, perpage, reset) {
      const that = this;
      this.loading = true;

      let data = Object.assign(
        {
          start_time: this.$getTimeValue(this.startTime),
          end_time: this.$getTimeValue(this.endTime),
          cpage: page,
          pagesize: perpage,
        },
        this.filterData && !reset ? this.filterData : {}
      );

      this.isActive = Math.random() * 100000000;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/get-roster-large-table/",
        data: data,
      })
        .then((res) => {
          that.page = page;
          that.itemsPerPage = perpage;
          that.RosterList = res.data;
          that.$emit("reset", reset);
          that.totalCount = res.totalcount;
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
        })
        .catch((err) => {
          that.RosterList = [];
          that.$Sleep(500).then(() => {
            that.loading = false;
          });
          that.$showMessage({
            title: that.$t("message_essweb_form_textField_errNoticeTitle"),
            type: "error",
            text: err,
          });
        });
    },
  },
};
</script>
<style scoped>
.loading_container {
  position: absolute;
  width: 100%;
  z-index: 1;
  margin-left: -12px;
  margin-top: -12px;
  background: rgba(0, 0, 0, 0.3);
}
</style>